<!-- @format -->

<div aria-labelledby="user-role" role="group" class="user-role-menu" [class.user-role-menu--mobile]="mobileMode">
  <div class="user-role-menu__header" aria-hidden="true" id="user-role">{{ "AUTH.USER_ROLE" | translate }}</div>
  @for (role of userRoleSelections; track role) {
    <a
      ngbDropdownItem
      role="menuitem"
      [href]="role.url"
      (blur)="blurMobileUserRoleMenu.emit($event)"
      (keydown.escape)="blurMobileUserRoleMenu.emit($event)"
      (keydown)="keydownPressed.emit($event)"
      [attr.aria-current]="role.active"
      class="user-role-menu__item anchor-button"
      data-cy="user-role">
      {{ role.nameKey | translate }}
      @if (role.active) {
        <fudis-icon [icon]="'check'" [color]="'primary'"></fudis-icon>
      }
    </a>
  }
</div>
